var React = require('react');

function IconLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".icon-left{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}")),React.createElement("g",{"id":"TAYLOR-MADE","key":1},React.createElement("g",{"id":"S4"},React.createElement("g",null,[React.createElement("circle",{"className":"icon-left","cx":"27.5","cy":"27.5","r":"26.5","key":0}),React.createElement("line",{"className":"icon-left","x1":"27","y1":"15","x2":"27","y2":"40","key":1}),React.createElement("line",{"className":"icon-left","x1":"11","y1":"28","x2":"27","y2":"28","key":2})])))]);
}

IconLeft.defaultProps = {"id":"Layer_2","viewBox":"0 0 55 55"};

module.exports = IconLeft;

IconLeft.default = IconLeft;
